import moment from 'moment';
import { getClientContacts } from '../../HttpRequests/clientContacts';
import { loadClientContacts } from '../State/clientContacts';

let lastGetTimestamp = null;

const cacheTTL = 60000;

export default ({ force } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'));

      if (now < (lastGetTimestamp + cacheTTL)) return;
    }
      
    lastGetTimestamp = Number(moment().format('x'));

    const params = {
      pagination: 0,
      sort: 'first_name,last_name'
    }

    const response = await getClientContacts({ params });

    dispatch(loadClientContacts(response.data.data));

  } catch (error) {
    
    throw error;

  }
}